export default {
    rs: {
        username: 'Korisničko ime',
        password: 'Lozinka',
        rememberMe: 'Zapamti',
        forgotPwd: 'Obnova lozinke',
        logIn: 'Prijavi me',
        obnovaLozinke: 'Obnova lozinke',
        obnovaLoznikeTekst: 'Unesite vaše korisničko ime i intrukcije će biti poslate na vaš email',
        reset: 'Pošalji',
        loginFailed: 'Neuspešna prijava na sistem. Proverite korinsičko ime i lozinku',
        novo: 'Novo',
        novi: 'Novi',
        nova: 'Nova',
        administracija: 'Administacija',
        navigacija: 'Navigacija',
        vozniPark: 'Vozni park',
        dashboard: 'Kokpit',
        profil: 'Moj profil',
        podesavanja: 'Podešavanja',
        odjava: 'Odjava',
        pretraga: 'Pretraga...',
        kreiraj: 'Kreiraj',
        filter: 'Filter',
        tipVozila: 'Tip Vozila',
        kategorijaVozila: 'Kategorija',
        markaVozila: 'Marka',
        modelVozila: 'Model',
        clear: 'Očisti',
        flota: 'Flota',
        zaposleni: 'Zaposleni',
        grupe: 'Grupe',
        podgrupeVozila: 'Podgrupe',
        registarskaOznaka: 'Registarska oznaka',
        grupaVozila: 'Grupa',
        podgrupaVozila: 'Podgrupa',
        godina: 'Godina',
        grupeVozila: 'Grupe vozila',
        markeVozila: 'Marke vozila',
        tipoviVozila: 'Tipovi vozila',
        naziv: 'Naziv',
        sacuvaj: 'Sačuvaj',
        dodajNovuPodgrupu: 'Dodaj novu podgrupu',
        obrisi: "Obriši",
        potvrda: "Potrebna potvrda",
        ne: "Ne",
        da: "Da",
        'da li zelite da obrisete podgrupu?': 'Da li želite da obrišete podgrupu',
        informacija: 'Informacija',
        greska: 'Greška',
        uspesnaAkcija: "Bravo",
        podaciSuUspecnoSacuvani: "Podaci su uspešno sačuvani",
        nesupesnoCuvanjePodataka: "Greška prilikom čuvanja podataka. Pokušajte ponovo",
        unauthorized: "Niste trenutno ulogovani. Bićete preusmereni na stranicu za prijavljivanje",
        neuspesnoUcitavanjePodataka: "Neuspešno učitavanje podataka",
        neuspesnoBrisanjePodataka: "Neuspešno brisanje podataka",
        uspesnoBrisanjePodataka: "Podaci su uspešno obrisani",
        'da li zelite da obrisete grupu': "Da li želite da obrišete grupu",
        statusiVozila: 'Statusi vozila',
        podrazumevan: 'Podrazumevan',
        nov: 'Nov',
        'da li zelite da obrisete status vozila': 'Da li želite da obrišete status vozila',
        'da li zelite da obrisete tip vozila': 'Da li želite da obrišete tip vozila?',
        opremaVozila: 'Oprema vozila',
        proizvodjac: 'Proizvođač',
        serijskiBroj: 'Serijski broj',
        slika: 'Slika',
        istekGarancije: 'Garancija',
        opis: 'Opis',
        'da li zelite da obrisete opremu vozila': 'Da li želite da obrišete opremu vozila',
        podaciFirme: 'Podaci o firmi',
        adresa: 'Adresa',
        telefon: 'Telefon',
        mesto: 'Mesto',
        faks: 'Faks',
        email: 'E-mail',
        pib: 'PIB',
        'da li zelite da obrisete marku vozila': 'Da li želite da obrišete marku vozila',
        dodajNovModel: 'Dodaj nov model vozila',
        'da li zelite da obrisete model vozila': 'Da li želite da obrišete model vozila',
        organizacionaStruktura: 'Organizaciona struktura',
        tip: 'Tip',
        'da li zelite da obrisete organizacionu strukturu': "Da li želite da obrišete organizacionu strukturu",
        osobe: 'Osobe',
        detaljiOsobe: 'Detalji osobe',
        ime: 'Ime',
        prezime: 'Prezime',
        radnoMesto: 'Radno mesto',
        napomena: 'Napomena',
        jmbg: 'Jmbg',
        brojVozackeDozvole: 'Broj vozačke dozvole',
        datumIstekaVozackeDozvole: 'Datum isteka vozačke dozvole',
        kategorijaVozackeDozvole: 'Kategorija vozačke dozvole',
        datumRodjenja: 'Datum rođenja',
        datumZaposlenja: 'Datum zaposlenja',
        brojPasosa: 'Broj pasoša',
        datumVazenjaPasosa: 'Datum vazenja pasoša',
        brojLicneKarte: 'Broj lične karte',
        datumIstekaLicneKarte: 'Datum isteka lične karte',
        poslovnica: 'Poslovnica',
        korisnickoIme: 'Korisničko ime',
        lozinka: 'Lozinka',
        izmeniPodatke: 'Izmena podataka',
        izmenaOsobe: 'Izmena osobe',
        promeniLozinku: 'Promeni lozinku',
        novaLozinka: 'Nova lozinka',
        potvrdiLozinku: 'Potvrdi lozinku',
        aktivanNalog: 'Aktivan nalog',
        aktivnaOsoba: 'Aktivan',
        izmenaSlike: 'Promeni sliku',
        izaberi: 'Izaberi',
        'Korisnicko ime vec postoji': 'Korisničko ime već postoji',
        funkcija: 'Funkcija',
        'da li zelite da obrisete zaposlenog': 'Da li želite da obrišete zaposlenog',
        vozackaDozvola: 'Vozačka dozvola',
        podaciOVozilu: 'Podaci o vozilu',
        izborGrupa: 'Izbor grupa',
        podaciONabavciVozila: 'Podaci o nabavci vozila',
        podaciOOsiguranju: 'Podaci o osiguranju',
        prodajaRashod: 'Prodaja/Rashod',
        b2bPodaciVozila: 'B2B podaci vozila',
        datumPrveRegistracije: 'Datum prve registracije',
        godinaProizvodnje: 'Godina proizvodnje',
        boja: 'Boja',
        brojOsovina: 'Broj osovina',
        brojSasije: 'Broj šasije',
        zapreminaMotora: 'Zapremina motora',
        brojMotora: 'Broj motora',
        masa: 'Masa',
        snagaMotora: 'Snaga motora',
        nosivost: 'Nosivost',
        kategorija: 'Kategorija',
        ukupnaMasa: 'Ukupna masa',
        brojSedista: 'Broj sedista',
        brojMestaZaStajanje: 'Broj mesta za stajanje',
        tahograf: 'Tahograf',
        stampaj: 'Štampaj',
        pripada: 'Pripada',
        statusVozila: 'Status vozila',
        normativPotrosnjeGoriva: 'Normativ potrošnje goriva',
        vrstaGoriva: 'Gorivo',
        norma: 'Norma',
        dozvoljenoOdstupanje: 'Dozvoljeno odstupanje',
        nacinPlacanja: 'Način plaćanja',
        datumNabavke: 'Datum nabavke',
        prosecnaNabavnaCena: 'Prosečna nabavna cena',
        stanjeKilometraze: 'Stanje kilometraže',
        brojMeseciOtplate: 'Broj meseci otplate',
        'mesecnaRata/amortizacija': 'Mesečna rata/amortizacija',
        ucesce: 'Učešće',
        'datumIstekaZakupa/lizinga': 'Datum isteka zakupa/lizinga',
        osiguranjeOdOdgovornosti: 'Osiguranje od odgovornosti',
        kaskoOsiguranje: 'Kasko osiguranje',
        osiguravajucaKuca: 'Osiguravajuća kuća',
        brojPolise: 'Broj polise',
        periodOsiguranja: 'Period osiguranja',
        do: 'Do',
        osiguranaSuma: 'Osigurana suma',
        premijskiStepen: 'Premijski stepen',
        premija: 'Premija',
        porezNaPremiju: 'Porez na premiju',
        taksePriRegistraciji: 'Takse pri registraciji',
        ukupno: 'Ukupno',
        ukupnoBezPdv: 'Ukupno (bez PDV-a)',
        'ucesceUSteti [%]': 'Učešće u šteti [%]',
        minimalnoUcesce: 'Minimalno učešće',
        mesecnaRata: 'Mesečna rata',
        nacinProdaje: 'Način prodaje',
        datum: 'Datum',
        iznos: 'Iznos',
        garazniBroj: 'Garažni broj',
        tipMotora: 'Tip motora',
        aktivan: 'Aktivan',
        nacinNabavkeVozila: 'Način nabavke',
        'da li zeliete da obrisete podatke o nabavci vozila': 'Da li želite da obrišete podatke o nabavci vozila?',
        troskoviGoriva: 'Troškovi goriva',
        troskoviServisa: 'Troškovi servisa',
        potrosnjaGoriva: 'Potrošnja goriva',
        troskoviVozila: 'Troškovi vozila',
        podsetnik: 'Podsetnik',
        osnovniPodaci: 'Osnovni podaci',
        podaciONabavci: 'Podaci o nabavci',
        gorivo: 'Gorivo',
        oprema: 'Oprema',
        komada: 'Komada',
        periodicneOpsteAktinosti: 'Periodične opšte aktivnosti',
        periodicneAktivnostiOdrzavanja: 'Periodične aktivnosti održavanja',
        posaljiEmail: 'Pošalji e-mail',
        status: 'Status',
        odrzavanje: 'Održavanje',
        vrsteOdrzavanja: 'Vrste održavanja',
        grupeDelova: 'Grupe delova',
        servisneOperacije: 'Servisne operacije',
        vrsteTroskovaVozila: 'Vrste troškova vozila',
        rezervniDelovi: 'Rezervni delovi',
        poslovniPartneri: 'Poslovni partneri',
        oznaka: 'Oznaka',
        preventivno: 'Preventivno',
        sort: 'Sort',
        korektivno: 'Korektivno',
        p: 'P',
        c: 'C',
        prevencija: 'Prevencija',
        korekcija: 'Korekcija',
        sklop: 'Sklop',
        vrstaOdrzavanja: 'Vrsta održavanja',
        tarifnaGrupa: 'Tarifna grupa',
        prikaziNaPutnomNalogu: 'Prikaži na putnom nalogu',
        'imaPravoPovrataPDV-a': 'Ima pravo povrata PDV-a',
        trosakOdrzavanjaVozila: 'Trošak održavanja vozila',
        ostaliTroskoviVozila: 'Ostali troškovi vozila',
        trosakOsoblja: 'Trošak osoblja',
        dnevnica: 'Dnevnica',
        id: 'ID',
        kataloskiBroj: 'Kataloški broj',
        'p/c': 'P/C',
        brend: 'Brend',
        oemBroj: 'OEM broj',
        grupaArtikla: 'Grupa artikla',
        podgrupaArtikla: 'Podgrupa artikla',
        jedinicaMere: 'Jedinica mere',
        cena: 'Cena',
        pdv: 'PDV',
        izvestajiTroskoviVozila: 'Izveštaj troškova vozila',
        light_theme: 'Svetla tema',
        dark_theme: 'Tamna tema',
        vrstaOsiguranja: 'Vrsta osiguranja',
        'da li zelite da obrisete vrstu odrzavanja': 'Da li želite da obrišete vrstu održavanja',
        'da li zelite da obrisete grupu delova': 'Da li želite da obrišete grupu delova',
        'da li zelite da obrisete servisnu operaciju': 'Da li želite da obrišete servisnu operaciju',
        'da li zelite da obrisete trosak vozila': 'Da li želite da obrišete trošak vozila',
        kazna: 'Kazna',
        putarina: 'Putarina',
        workUnits: 'Work units',
        tekuciRacun: 'Tekući račun',
        kontaktPodaci: 'Kontakt podaci',
        webAdresa: 'Web adresa',
        kupac: 'Kupac',
        dobavljac: 'Dobavljač',
        sifra: 'Šifra',
        'da li zelite da obrisete poslovnog partnera': 'Da li želite da obrišete poslovnog partnera',
        grupaDelova: 'Grupa delova',
        prijavaKvara: 'Prijava kvara',
        dokumenta: 'Dokumenta',
        vozilo: 'Vozilo',
        prijavio: 'Prijavio',
        opisKvara: 'Opis kvara',
        dozvoljenaVozila: 'Dozvoljena vozila',
        odobravanjePrijaveKvara: 'Odobravanje prijave kvara',
        broj: 'Broj',
        kvarPrijavio: 'Kvar prijavio',
        prihvati: 'Prihvati',
        odbi: 'Odbi',
        'prihvati/odbi': 'Prihvati/Odbi',
        'da li ste sigurni da zelite da prihvatite kvar': 'Da li ste sigurni da želite da prihvatite kvar',
        'da li ste sigurni da zelite da obrisete kvar': 'Da li ste sigurni da želite da obrišete kvar',
        radniNalog: 'Radni nalog',
        eksterniRadniNalog: 'Eksterni radni nalog',
        delovi: 'Delovi',
        wu: 'h',
        servisnaOperacija: 'Servisna operacija',
        zakljuciDokument: 'Zaključi dokument',
        trebovanje: 'Trebovanje',
        rezervniDeo: 'Rezervni deo',
        kolicina: 'Količina',
        dodajOperaciju: 'Dodaj operaciju',
        serviser: 'Serviser',
        brojDokumenta: 'Broj dokumenta',
        razlogOdbijanjaKvara: 'Razlog odbijanja kvara',
        unesiteRazlogZaOdbijanjeKvara: 'Unesite razlog za odbijanje kvara',
        utroseno: 'Utrošeno',
        skladiste: 'Skladište',
        dodajDelove: 'Dodaj delove',
        kreirajTrebovanje: 'Kreiraj trebovanje',
        zaliha: 'Zaliha',
        pretragaRezervnihDelova: 'Pretraga rezervnih delova',
        dodajRezervniDeo: 'Dodaj rezervni deo',
        dodaj: 'Dodaj',
        'da li zelite da obrisete trebovanje za rezervni deo': 'Da li želite da obrišete trebovanje rezervni deo',
        'rezervni deo je dodan trebovanju': 'Rezervni deo je dodan trebovanju',
        'trebovanje je moguce kreirati samo za prethodno sacuvan radni nalog': 'Trebovanje je moguće kreirati samo za prethodno sačuvan radni nalog',
        'da li zelite da zakljucite dokument': 'Da li želite da zaključite dokument',
        'dokument je zakljucen': 'Dokument je uspešno zaključen. Dalje izmene nisu dozvoljene',
        izdatnica: 'Izdatnica',
        izdataKolicina: 'Izdata količina',
        poRadnomNalogu: 'Po radnom nalogu',
        delovePrimio: 'Delove primio',
        'da li zelite da zakljucite izdatnicu': 'Da li želite da zaključite izdatnicu',
        dokumentJeZakljucen: 'Dokument je uspešno zaključen',
        potvrdaRadnihNaloga: 'Potvrda radnih naloga',
        dokumentKreirao: 'Dokument kreirao',
        potvrdjenaKolicina: 'Potvrđeno',
        potvrdaRadnogNaloga: 'Potvrda radnog naloga',
        potvrdiRadniNalog: 'Potvrdi radni nalog',
        'dokument nije moguce ucitati': 'Dokument nije moguće učitati',
        'postoje stavke sa ne dodeljenom vrstom odrzavanja': 'Postoje stavke sa ne dodeljenom vrstom održavanja. Da li ipak želite da potvrdite dokument',
        'fakturaNaOsnovuRadnogNaloga': 'Faktura servisera (sa radnim nalogom)',
        'fakturaBezRadnogNaloga': 'Faktura servisera (bez radnog naloga)',
        saRadnimNalogom: 'Sa radnim nalogom',
        bezRadnogNaloga: 'Bez radnog naloga',
        radniNalozi: 'Radni nalozi',
        fakture: 'Fakture',
        skladisteDelova: 'Skladište delova',
        sopstveniDelovi: 'Sopstveni delovi',
        stavke: 'Stavke',
        dodajStavku: 'Dodaj stavku',
        referenca: 'Referenca',
        'ukupan iznos se ne slaze': "Ukupan iznos se ne slaže",
        'da li zelite da zakljucite fakturu': "Da li želite da zaključite fakturu",
        potvrdaPovratnice: 'Potvrda povratnice',
        prijemnica: 'Prijemnica',
        zalihe: 'Zalihe',
        brojFaktureDobavljaca: 'Broj fakture dobavljača',
        rokPlacanja: 'Rok plaćanja',
        pregledZaliha: 'Pregled zaliha',
        pretrazi: 'Pretraži',
        nazivArtikla: 'Naziv artikla',
        poslednjaNabavnaCena: 'Poslednja nabavna cena',
        minZaliha: 'Min.Zaliha',
        maxZaliha: 'Max.Zaliha',
        vrednost: 'Vrednost',
        robuVratio: 'Robu vratio',
        fakturaTroskovaVoznogParka: 'Faktura troškova voznog parka',
        vrsteTroska: 'Vrste troška',
        robuPrimio: 'Robu primio',
        autoServis: 'Autoservis',
        'podaci nisu sacuvani jer skladiste nije izabrano': 'Podaci nisu sačuvani jer skladište nije izabrano',
        'nisu sva obavezna polja popunjena': 'Nisu sva obavezna polja popunjena',
        'potvrdjena kolicina ne sme biti veca od kolicine':'Potvđena količina ne sme biti veća od količine',
        sacuvajNalog: 'Sačuvaj nalog',
        delatnost: 'Delatnost',
        'kolicina na stavkama i na raspodeli se ne slazu': 'Količina na stavkama i na raspodeli se ne slažu',
        'raspodela troskova po vozilima': 'Raspodela troškova po vozilima',
        pregledDokumenta: 'Pregled dokumenta',
        prethodniDokument: 'Prethodni dokument',
        povezaniDokumenti: 'Povezani dokumenti',
        deloveIzdao: 'Delove izdao',
        deloveVratio: 'Delove vratio',
        detaljiDokumenta: 'Detalji dokumenta',
        fakturisaniDelovi: 'Fakturisani delovi',
        pretragaDokumenata: 'Pretraga dokumenata',
        podesavanjeSistema: 'Podešavanje sistema',
        cenaRadnogSata: 'Cena radnog sata',
        koristiZalihe: 'Koristi zalihe',
        upozoriPre: 'Upozori pre',
        primaoci: 'Primaoci',
        primaoc: 'Primaoc',
        ukljucen: 'Ukljucen',
        podsetnici: 'Podsetnici',
        dodajPodsetnik: 'Dodaj podsetnik',
        dodajPodsetnikVozila: 'Dodaj podsetnik vozila',
        dodajPrimaoca: 'Dodaj primaoca',
        zaglavljeDokumenta: 'Zaglavlje Dokumenta',
        dana: 'Dana',
        imeIPrezime: 'Ime i prezime',
        podaciZaposlenog: 'Podaci zaposlenog',
        korisnickiNalog: 'Korisnicki nalog',
        poruke: 'Poruke',
        obrisiSve: 'Obriši sve',
        pogledajSve: 'Pogledaj sve',
        nemateNovihPoruka: 'Nemate novih poruka',
        razlika: 'Razlika',
        osoba: 'Osoba',
        podsetniciVozila: 'Podsetnici vozila',
        dodajPodsetnikOsobe: 'Dodaj podsetnik osobe',
        podsetniciOsoba: 'Podsetnici osoba',
        km: ' km',
        danaUpozoriPre: ' dana',
        danUpozoriPre: ' dan',
        'da li zelite da obrisete podsetnik': 'Da li želite da obrišete podsetnik',
        prikazSaKilometrazom: 'Prikaz sa kilometražom',
        datumskiPrikaz: 'Datumski prikaz',
        evidencijaRV: 'Evidencija RV',
        unosOdsustva: 'Unos odsustva',
        vrstaOdsustva: 'Vrsta odsustva',
        od: 'Od',
        odDatuma: 'Od datuma',
        doDatuma: 'Do datuma',
        'podaci nisu validni': 'Podaci nisu validni. Ispravite sve greške',
        'da li zelite da obrisete odsustvo': 'Da li želite da obrišete odsustvo',
        januar: 'Januar',
        februar: 'Februar',
        mart: 'Mart',
        april: 'April',
        maj: 'Maj',
        jun: 'Jun',
        jul: 'Jul',
        avgust: 'Avgust',
        septembar: 'Septembar',
        oktobar: 'Oktobar',
        novembar: 'Novembar',
        decembar: 'Decembar',
        evidencijaRadnogVremena: 'Evidencija radnog vremena',
        mesec: 'Mesec',
        mestoTroska: 'Mesto troška',
        vozac: 'Vozač',
        pocetakRV: 'Početak RV',
        krajRV: 'Kraj RV',
        trajanjeRV: 'Trajanje RV',
        vremeVoznje: 'Vreme vožnje',
        ostaloRV: 'Ostalo RV',
        raspolozivoVreme: 'Raspoloživo vreme',
        odmorURV: 'Odmor URV',
        nocnoRadnoVreme: 'Noćno radno vreme',
        placenoOdsustvo: 'Plaćeno odsustvo',
        pregledReferentnihPerioda: 'Pregled referentnih perioda',
        period: 'Period',
        nedelja: 'Nedelja',
        ukupnoVreme: 'Ukupno vreme',
        nedelja1: 'Nedelja 1',
        nedelja2: 'Nedelja 2',
        nedelja3: 'Nedelja 3',
        nedelja4: 'Nedelja 4',
        nedelja5: 'Nedelja 5',
        prosecnoVreme: 'Prosečno vreme',
        ukupnoRV: 'Ukupno RV',
        produzenoVreme: 'Produženo RV',
        rvNedelja: 'RV Nedelja',
        preostaloVremeDanas: 'Preostalo vreme danas',
        preostaloVremeNedelja: 'Preostalo vreme nedelja',
        preostaloVremePeriod: 'Preostalo vreme period',
        prosecnoVremeUPeriodu: 'Prosecno vreme u periodu',
        preostaloVremeSutra: 'Preostalo vreme sutra',
        rvDanas: 'RV Danas',
        izvestajPreostalogRadnogVremena: 'Izveštaj preostalog radnog vremena',
        uvozTahografa: 'Uvoz tahografa',
        naloziZaSluzbenoPutovanje: 'Nalozi za službeno putovanje',
        putniNalozi: 'Putni nalozi',
        brojNaloga: 'Broj naloga',
        datumPolaska: 'Datum polaska',
        datumZavrsetka: 'Datum završetka',
        brojSati: 'Broj sati',
        brojDnevnica: 'Broj dnevnica',
        iznosDnevnice: 'Iznos dnevnice',
        predjenoKM: 'Predjeno KM',
        unosPutnogNaloga: 'Unos putnog naloga',
        brojPutnogNaloga: 'Broj putnog naloga',
        vrstaPrevoza: 'Vrsta prevoza',
        relacija: 'Relacija',
        clanPosade: 'Član posade',
        podaciOKretanju: 'Podaci o kretanju',
        troskovi: 'Troškovi',
        vremePolaska: 'Vreme polaska',
        mestoPolaska: 'Mesto polaska',
        mestoDolaska: 'Mesto dolaska',
        vremeDolaska: 'Vreme dolaska',
        datumDolaska: 'Datum dolaska',
        ukupnoKM: 'Ukupno KM',
        stanjeKM: 'Stanje KM',
        'datum unosa': 'Datum unosa',
        'naziv datoteke': 'Naziv datoteke',
        'Choose a file or drop it here...': 'Izaberite datoteku',
        ukupnaKM: 'Ukupna KM',
        pocetnaKM: 'Početna Kilometraža',
        popust: 'Popust %',
        servisnaFaktura: 'Servisna faktura',
        kilometraza: 'Kilometraža',
        dodajNalog: 'Dodaj nalog',
        krajnjaKM: 'Krajnja KM',
        krajnjaKilometraza: 'Krajnja Kilometraža',
        predjenaKilometraza: 'Predjena kilometraža',
        pregledPutnihNaloga: 'Pregled putnih naloga',
        polaznaKM: 'Polazna KM',
        'ovaj putni nalog je vec zakljucan i izmene nisu dozvoljene': 'Ovaj putni nalog je vec zaključan i izmene nisu dozvoljene',
        dodajKretanje: 'Dodaj kretanje',
        vrstaTroska: 'Vrsta troška',
        datumIVremePolaska: 'Datum i vreme polaska',
        datumIVremeDolaska: 'Datum i vreme dolaska',
        ukupnaKilometraza: 'Ukupna kilometraža',
        ukupanTrosak: 'Ukupan trošak',
        dodajTrosak: 'Dodaj trošak',
        prevozZaSopstvenePotrebe: 'Za sopstvene potrebe',
        javniPrevoz: 'Javni prevoz',
        brojRadnihDanaUNedelji: 'Broj radnih dana u nedelji',
        brojRadnihSatiUDanu: 'Broj radnih sati u danu',
        kursEvra: 'Kurs EUR',
        iznosDnevniceVozaca: 'Iznos dnevnice vozača',
        osveziPoziciju: 'Osveži poziciju',
        automatskoOsvezavanje: 'Automatsko osvežavanje',
        interval: 'Interval',
        'pozicije su osvezene': 'Pozicije su osvežene',
        min: 'Min',
        pregledPodsetnikaPoPrimaocima: 'Pregled podsetnika po primaocima',
        'da li zelite da zakljucite putni nalog': 'Da li želite da zaključite putni nalog?',
        zadatak: 'Zadatak',
        putniNalog: 'Putni nalog',
        uvozPodataka: 'Uvoz podataka',
        uvozSipanjaGoriva: 'Uvoz goriva',
        izvestaji: 'Izveštaji',
        adBlue: 'Ad Blue',
        takse: 'Takse',
        osiguranje: 'Osiguranje',
        amortizacija: 'Amortizacija',
        inventarskiVozniPark: 'Inventarski vozni park',
        preventive: 'Preventivni troškovi',
        corrective: 'Korektivni troškovi',
        welcome: 'Dobrodošli',
        ukupniTroskovi: 'Ukupni troškovi',
        ukupnoPrevezeniTeret: 'Ukupno prevezeni teret',
        ukupnoPredjenaKilometraza: 'Ukupno pređena kilometraža',
        pcTroskoviPoGodinama: 'Preventini / Korektivni troškovi održavanja po godinama',
        ucesceUUkupnimTroskovima: 'Učešće u ukupnim troškovima',
        pcTroskoviPoGrupama: 'Preventini / Korektivni troškovi održavanja po grupama',
        troskoviOdrzavanjaPoVozilima: 'Troškovi održavanja po vozilima (top 10)',
        uvozKretanjaVozila: 'Uvoz kretanja vozila',
        evidencijaSipanjaGoriva: 'Evidencija sipanja i prosečna potrošnja goriva',
        stanjeKilometrazePriSipanju: 'Stanje kilometraže pri sipanju',
        predjenoKilometaraNakonPrethodnogSipanja: 'Pređeni kilometri nakon prethodnog sipanja',
        vrednostSipanogGoriva: 'Vrednost sipanog goriva',
        sipanaKolicina: 'Sipana količina',
        prosecnaPotrosnjaGoriva: 'Prosečna potrošnja goriva',
        normiranaPotrosnja: 'Normirana potrošnja',
        prekoracenjeNorme: 'Prekoračenje norme',
        prekoracenjeULitrama: 'Prekoračenje u litrama',
        prekoracenjeUVrednosti: 'Prekoračenje u novcu',
        total: 'Ukupno',
        tipDokumenta: 'Dokument',
        troskoviOdrzavanja: 'Troškovi održavanja',
        iznosAmortizacije: 'Iznos amortizacije',
        preostaliIznos: 'Preostali iznos',
        predjeniKilometriIPotrosnjaGoriva: 'Pređeni kilometri i potrošnja goriva',
        predjeniKilometri: 'Pređeni kilometri (km)',
        potrosnjaGorivaULitrama: 'Potrošnja goriva (l)',
        troskoviPoVozilima: 'Troškovi po vozilima',
        markaIModel: 'Marka i model vozila',
        trosakPoKm: 'Trošak po km',
        izvestajPredjeniKilometri: 'Pređeni kilometri',
        ukupnoPredjeniKilometriVozila: 'Ukupno pređeni kilometri vozila',
        ucesceUUkupnoPredjenimKilometrimaVozila: 'Učešće u ukupno pređenim kilometrima vozila',
        ucesceUUkupnoPredjenimKilometrimaVoznogParka: 'Učešće u ukupno pređenim kilometrima celog voznog parka',
        predjeniKilometriPoVozilima: 'Pređeni kilometri po vozilima',
        predjeniKilometriPoVozacima: 'Pređeni kilometri po vozačima',
        kretanje: 'Kretanje',
        radnoVreme: 'Radno vreme',
        pregledKretanjaVozila: 'Pregled kretanja vozila',
        pregledKretanjaVozaca: 'Pregled kretanja vozača',
        prosek: 'Prosek',
        ostaliTroskovi: 'Ostali troškovi',
        osnovica: 'Osnovica',
        pdvStopa: 'PDV %',
        'pretraga dokumenata': 'Pretraga dokumenata',
        nemaUnetihStavki: 'Nema unetih stavki',
        korisnickeTransakcije: 'Korisničke transakcije',
        transakcijaNijeDozvoljena: 'Transakcija nije dozvoljena za vaš korisnički nalog',
        upozorenje: 'Upozorenje',
        mestoRodjenja: 'Mesto rođenja',
        b2bPodaci: 'B2B Podaci',
        provajder: 'Provajder',
        vrstaProvajdera: 'Vrsta provajdera',
        gps: 'GPS',
        unosAktivnostiIObradaGpsPodataka: 'Unos aktivnosti i obrada GPS podataka',
        izvor: 'Izvor',
        pocetnaLokacija: 'Početna lokacija',
        krajnjaLokacija: 'Krajnja lokacija',
        aktivnost: 'Aktivnost',
        trajanjeAktivnosti: 'Trajanje aktivnosti',
        ucitajSaGpsa: 'Učitaj sa GPS-a',
        unosIzmenaAktivnosti: 'Unos / izmena aktivnosti',
        za: 'za',
        pre: 'pre',
        stete: 'Štete',
        unosStetnogDogadjaja: 'Unos štetnog događaja',
        pregledSteta: 'Pregled šteta',
        brojStete: 'Broj štete',
        brojZapisnika: 'Broj zapisnika',
        otkazi: 'Otkaži',
        zapisnikStete: 'Zapisnik štete',
        steta: 'Šteta',
        brojSteteSaZapisnika: 'Broj zapisnika',
        datumZakljucenja: 'Datum zaključenja',
        zakljuciStetu: 'Zaključi štetu',
        osiguranjePriznalo: 'Osiguranje priznalo',
        'steta je vec zakljucena. dalje izmene nisu dozvoljene': 'Šteta je već zaključena. Dalje izmene nisu dozvoljene',
        novaPoruka: 'Nova sistemska poruka',
        voziloNijePronadjeno: 'Vozilo nije pronađeno',
        rezultatPretrage: 'Rezultat pretrage',
        mojProfil: 'Moj profil',
        'vasa lozinka je uspesno promenjena': 'Vaša lozinka je uspešno promenjena',
        nabavnaCena: 'Nabavna cena',
        spojiDane: 'Spoji dane',
        ukupnoMinuta: 'Ukupno minuta',
        ukupnoSati: 'Ukupno sati',
        'nije moguce spojiti radno vreme. vozac se razlikuje': 'Nije moguće spojiti radno vreme - vozač se razlikuje',
        'nije moguce spojiti radno vreme. razlika datuma je razlicita od 1': 'Nije moguće spojiti radno vreme. Razlika datuma je različita od 1',
        unosTroskaSluzbenogPuta: 'Unos troška službenog puta',
        izmenaKilometrazeSipanja: 'Izmena kilometraže sipanja',
        analitikaTroskovaVozila: 'Analitika troškova održavanja',
        iznosZaObracun: 'Iznos za obračun',
        tipStavke: 'R/D'
    },
    "tr": {
        username: 'Kullanıcı adı',
        password: 'Parola',
        rememberMe: 'Hatırlamak',
        forgotPwd: 'Şifre kurtarma',
        logIn: 'Beni kaydet',
        obnovaLozinke: 'Şifre kurtarma',
        obnovaLoznikeTekst: 'Kullanıcı adınızı girin ve talimatlar e-postanıza gönderilecektir',
        reset: 'Gönder',
        loginFailed: 'Sistem girişi başarısız oldu. Kullanıcı adını ve şifreyi kontrol edin',
        novo: 'Yeni',
        novi: 'Yeni',
        nova: 'Yeni',
        administracija: 'Yönetim (değiştir | kaynağı değiştir)',
        navigacija: 'Navigasyon',
        vozniPark: 'Filo',
        dashboard: 'Kokpit',
        profil: 'Benim profilim',
        podesavanja: 'Ayarlar',
        odjava: 'Oturumu Kapat',
        pretraga: 'Arama...',
        kreiraj: 'Oluşturmak',
        filter: 'Filtrele',
        tipVozila: 'Araç tipi',
        kategorijaVozila: 'Kategori',
        markaVozila: 'Marka',
        modelVozila: 'Modeli',
        clear: 'Temizleyin',
        flota: 'Filo',
        zaposleni: 'Personel',
        grupe: 'Gruplar',
        podgrupeVozila: 'Alt gruplar',
        registarskaOznaka: 'Kayıt numarası',
        grupaVozila: 'Grup',
        podgrupaVozila: 'Alt grup',
        godina: 'Yıl',
        grupeVozila: 'Araç grupları',
        markeVozila: 'Araç markaları',
        tipoviVozila: 'Araç türleri',
        naziv: 'İsim Soyisim',
        sacuvaj: 'Kaydet',
        dodajNovuPodgrupu: 'Yeni bir alt grup ekleyin',
        obrisi: "Silme",
        potvrda: "Teyit gereklidir",
        ne: "Değil",
        da: "Evet",
        'da li zelite da obrisete podgrupu?': 'Grubu silmek istiyor musunuz?',
        informacija: 'Bilgi',
        greska: 'Hata',
        uspesnaAkcija: "Aferin",
        podaciSuUspecnoSacuvani: "Veri başarıyla kaydedildi",
        nesupesnoCuvanjePodataka: "Veri kaydedilirken hata oluştu. Lütfen tekrar deneyin",
        unauthorized: "Şu anda giriş yapmadınız. Giriş sayfasına yönlendirileceksiniz",
        neuspesnoUcitavanjePodataka: "Veriler yüklenemedi",
        neuspesnoBrisanjePodataka: "Veriler silinemedi",
        uspesnoBrisanjePodataka: "Veriler başarıyla silindi",
        'da li zelite da obrisete grupu': "Grubu silmek istiyormusunuz",
        statusiVozila: 'Araç durumları',
        podrazumevan: 'Varsayılan',
        nov: 'Kasım',
        'da li zelite da obrisete status vozila': 'Araç durumunu silmek istiyor musunuz',
        'da li zelite da obrisete tip vozila': 'Araç tipini silmek istiyor musunuz?',
        opremaVozila: 'Araç ekipmanı',
        proizvodjac: 'Üretici firma',
        serijskiBroj: 'Seri numarası',
        slika: 'Boyama',
        istekGarancije: 'Garanti',
        opis: 'Açıklama',
        'da li zelite da obrisete opremu vozila': 'Araç ekipmanını silmek istiyor musunuz',
        podaciFirme: 'Şirket Bilgisi',
        adresa: 'Adres',
        telefon: 'Telefon',
        mesto: 'Yer',
        faks: 'Faks',
        email: 'E-posta',
        pib: 'VERGİ NUMARASI',
        'da li zelite da obrisete marku vozila': 'Araç markasını silmek istiyor musunuz',
        dodajNovModel: 'Yeni bir araç modeli ekle',
        'da li zelite da obrisete model vozila': 'Araç modelini silmek istiyor musunuz',
        organizacionaStruktura: 'örgütsel yapı',
        tip: 'Tür',
        'da li zelite da obrisete organizacionu strukturu': "Kuruluş yapısını silmek istiyor musunuz",
        osobe: 'İnsanlar',
        detaljiOsobe: 'Kişi ayrıntıları',
        ime: 'İsim Soyisim',
        prezime: 'Soyadı',
        radnoMesto: 'İş yeri',
        napomena: 'Not',
        jmbg: 'Jmbg',
        brojVozackeDozvole: 'Sürücü belgesi numarası',
        datumIstekaVozackeDozvole: 'Sürücü belgesi son kullanma tarihi',
        kategorijaVozackeDozvole: 'Kategorija vozačke dozvole',
        datumRodjenja: 'Doğum tarihi',
        datumZaposlenja: 'İstihdam tarihi',
        brojPasosa: 'Pasaport numarası',
        datumVazenjaPasosa: 'Pasaport geçerlilik tarihi',
        brojLicneKarte: 'kimlik Numarası',
        datumIstekaLicneKarte: 'Kimlik son kullanma tarihi',
        poslovnica: 'Şube',
        korisnickoIme: 'Kullanıcı adı',
        lozinka: 'Parola',
        izmeniPodatke: 'Veri modifikasyonu',
        izmenaOsobe: 'Kişi değişikliği',
        promeniLozinku: 'Şifreyi değiştir',
        novaLozinka: 'Yeni Şifre',
        potvrdiLozinku: 'Şifreyi Onayla',
        aktivanNalog: 'Aktif hesap',
        aktivnaOsoba: 'Aktif',
        izmenaSlike: 'Resmi değiştir',
        izaberi: 'seçmek',
        'Korisnicko ime vec postoji': 'Kullanıcı adı zaten var',
        funkcija: 'Fonksiyon',
        'da li zelite da obrisete zaposlenog': 'Bir çalışanı silmek istiyor musunuz',
        vozackaDozvola: 'Ehliyet',
        podaciOVozilu: 'Araç verileri',
        izborGrupa: 'Grup seçimi',
        podaciONabavciVozila: 'Araç tedarik verileri',
        podaciOOsiguranju: 'Sigorta verileri',
        prodajaRashod: 'Satışlar / giderler',
        b2bPodaciVozila: 'B2B araç verileri',
        datumPrveRegistracije: 'İlk kayıt tarihi',
        godinaProizvodnje: 'Üretim yılı',
        boja: 'Renk',
        brojOsovina: 'Aks sayısı',
        brojSasije: 'Shacija numarası',
        zapreminaMotora: 'Motor hacmi',
        brojMotora: 'Motor sayısı',
        masa: 'kitle',
        snagaMotora: 'Motor gücü',
        nosivost: 'Yükleme kapasitesi',
        kategorija: 'Kategori',
        ukupnaMasa: 'Toplam ağırlık',
        brojSedista: 'koltukların sayısı',
        brojMestaZaStajanje: 'Ayakta kalan yerlerin sayısı',
        tahograf: 'Takograf',
        stampaj: 'Yazdır',
        pripada: 'Ait olmak',
        statusVozila: 'Araç durumu',
        normativPotrosnjeGoriva: 'Yakıt tüketimi standardı',
        vrstaGoriva: 'Yakıt',
        norma: 'Norma',
        dozvoljenoOdstupanje: 'Toleransa izin verildi',
        nacinPlacanja: 'Ödeme şekli',
        datumNabavke: 'Satınalma tarihi',
        prosecnaNabavnaCena: 'Ortalama satın alma fiyatı',
        stanjeKilometraze: 'Kilometre durumu',
        brojMeseciOtplate: 'Geri ödeme ayı sayısı',
        'mesecnaRata/amortizacija': 'Aylık taksit / amortisman',
        ucesce: 'Katılım',
        'datumIstekaZakupa/lizinga': 'Kiralama / kiralama bitiş tarihi',
        osiguranjeOdOdgovornosti: 'Sorumluluk sigortası',
        kaskoOsiguranje: 'Araba sigortası',
        osiguravajucaKuca: 'Ev Sigortası',
        brojPolise: 'Poliçe numarası',
        periodOsiguranja: 'Sigorta süresi',
        do: 'İçin',
        osiguranaSuma: 'Toplam sigortalı',
        premijskiStepen: 'Premium derece',
        premija: 'Ödül',
        porezNaPremiju: 'Prim vergisi',
        taksePriRegistraciji: 'Kayıt ücretleri',
        ukupno: 'Toplamda',
        ukupnoBezPdv: 'Toplam (PDV olmadan)',
        'ucesceUSteti [%]': 'Hasara katılım [%]',
        minimalnoUcesce: 'Minimum katılım',
        mesecnaRata: 'Aylık ödeme',
        nacinProdaje: 'Satış yöntemi',
        datum: 'tarih',
        iznos: 'Miktar',
        garazniBroj: 'Garaj numarası',
        tipMotora: 'Motor tipi',
        aktivan: 'Aktif',
        nacinNabavkeVozila: 'Tedarik yöntemi',
        'da li zeliete da obrisete podatke o nabavci vozila': 'Araç tedarik verilerini silmek istiyor musunuz?',
        troskoviGoriva: 'Yakıt maliyetleri',
        troskoviServisa: 'Servis maliyetleri',
        potrosnjaGoriva: 'Yakıt tüketimi',
        troskoviVozila: 'Araç maliyetleri',
        podsetnik: 'Hatırlatma',
        osnovniPodaci: 'Temel bilgiler',
        podaciONabavci: 'Tedarik verileri',
        gorivo: 'Yakıt',
        oprema: 'Ekipmanlar',
        komada: 'Adet',
        periodicneOpsteAktinosti: 'Periyodik aktiviteler',
        periodicneAktivnostiOdrzavanja: 'Periyodik bakım faaliyetleri',
        posaljiEmail: 'Eposta gönder',
        status: 'Durum',
        odrzavanje: 'Bakım',
        vrsteOdrzavanja: 'Bakım türleri',
        grupeDelova: 'Parça grupları',
        servisneOperacije: 'Servis işlemleri',
        vrsteTroskovaVozila: 'Araç maliyetleri türleri',
        rezervniDelovi: 'Yedek parçalar',
        poslovniPartneri: 'İş ortakları',
        oznaka: 'Etiket',
        preventivno: 'Önleyici',
        sort: 'Çeşit',
        korektivno: 'Düzeltici',
        p: 'Ö',
        c: 'D',
        prevencija: 'Önleme',
        korekcija: 'Düzeltme',
        sklop: 'Sklop',
        vrstaOdrzavanja: 'Bakım türü',
        tarifnaGrupa: 'Tarife grubu',
        prikaziNaPutnomNalogu: 'Seyahat sırasına göre göster',
        'imaPravoPovrataPDV-a': 'KDV iadesi alma hakkına sahiptir',
        trosakOdrzavanjaVozila: 'Araç bakım maliyeti',
        ostaliTroskoviVozila: 'Diğer araç maliyetleri',
        trosakOsoblja: 'Personel masrafı',
        dnevnica: 'Günlük',
        id: 'ID',
        kataloskiBroj: 'Katalog numarası',
        'p/c': 'Ö/D',
        brend: 'Marka',
        oemBroj: 'OEM numarası',
        grupaArtikla: 'Öğe grubu',
        podgrupaArtikla: 'Makale alt grubu',
        jedinicaMere: 'Ölçü birimi',
        cena: 'fiyat',
        pdv: 'KDV',
        izvestajiTroskoviVozila: 'Araç maliyet raporu',
        light_theme: 'Parlak tema',
        dark_theme: 'Koyu tema',
        vrstaOsiguranja: 'Vrsta osiguranja',
        'da li zelite da obrisete vrstu odrzavanja': 'Bakım türünü silmek istiyor musunuz',
        'da li zelite da obrisete grupu delova': 'Bir grup parçayı silmek istiyor musunuz?',
        'da li zelite da obrisete servisnu operaciju': 'Servis işlemini silmek istiyor musunuz?',
        'da li zelite da obrisete trosak vozila': 'Aracın ücretini silmek istiyor musunuz',
        kazna: 'Ceza',
        putarina: 'Geçiş ücreti',
        workUnits: 'Çalışma birimleri',
        tekuciRacun: 'Mevcut hesap',
        kontaktPodaci: 'Kontakt podaci',
        webAdresa: 'internet adresi',
        kupac: 'Alıcı',
        dobavljac: 'Tedarikçi',
        sifra: 'Kod',
        'da li zelite da obrisete poslovnog partnera': 'Muhatabı silmek istiyor musunuz',
        grupaDelova: 'Parça grubu',
        prijavaKvara: 'Hata raporu',
        dokumenta: 'Belgeler',
        vozilo: 'Araç',
        prijavio: 'Bildirildi',
        opisKvara: 'Arıza açıklaması',
        dozvoljenaVozila: 'İzin verilen araçlar',
        odobravanjePrijaveKvara: 'Odobravanje prijave kvara',
        broj: 'Numara',
        kvarPrijavio: 'Hata bildirildi',
        prihvati: 'Kabul etmek',
        odbi: 'Reddet',
        'prihvati/odbi': 'Kabul et / reddet',
        'da li ste sigurni da zelite da prihvatite kvar': 'Bir arızayı kabul etmek istediğinizden emin misiniz',
        'da li ste sigurni da zelite da obrisete kvar': 'Hatayı temizlemek istediğinizden emin misiniz?',
        radniNalog: 'İş emri',
        eksterniRadniNalog: 'Harici iş emri',
        delovi: 'Parçalari',
        wu: 'h',
        servisnaOperacija: 'Servis operasyonu',
        zakljuciDokument: 'Zaključi dokument',
        trebovanje: 'Gereklilik',
        rezervniDeo: 'Yedek parça',
        kolicina: 'Miktar',
        dodajOperaciju: 'İşlem ekle',
        serviser: 'Seriviser',
        brojDokumenta: 'Belge sayısı',
        razlogOdbijanjaKvara: 'Başarısızlığın reddedilme nedeni',
        unesiteRazlogZaOdbijanjeKvara: 'Arızayı reddetme nedenini girin',
        utroseno: 'Susturuldu',
        skladiste: 'Stok',
        dodajDelove: 'Parça ekle',
        kreirajTrebovanje: 'Talep oluşturun',
        zaliha: 'Stok',
        pretragaRezervnihDelova: 'Yedek parça arama',
        dodajRezervniDeo: 'Yedek parça ekleyin',
        dodaj: 'Ekle',
        'da li zelite da obrisete trebovanje za rezervni deo': 'Gerekli yedek parçayı silmek istiyor musunuz',
        'rezervni deo je dodan trebovanju': 'Talep üzerine yedek parça eklenir',
        'trebovanje je moguce kreirati samo za prethodno sacuvan radni nalog': 'Bir talep yalnızca önceden kaydedilmiş bir iş emri için oluşturulabilir',
        'da li zelite da zakljucite dokument': 'Belgeyi kapatmak istiyor musunuz',
        'dokument je zakljucen': 'Belge başarıyla tamamlandı. Daha fazla değişikliğe izin verilmez.',
        izdatnica: 'Bir hain',
        izdataKolicina: 'Verilen miktar',
        poRadnomNalogu: 'İş emri ile',
        delovePrimio: 'Alınan parçalar',
        'da li zelite da zakljucite izdatnicu': 'Sorunu bitirmek istiyor musun',
        dokumentJeZakljucen: 'Belge başarıyla tamamlandı',
        potvrdaRadnihNaloga: 'İş emirlerinin teyidi',
        dokumentKreirao: 'Belge oluşturuldu',
        potvrdjenaKolicina: 'Onaylanmış',
        potvrdaRadnogNaloga: 'İş emri onayı',
        potvrdiRadniNalog: 'İş emrini onaylayın',
        'dokument nije moguce ucitati': 'Belge yüklenemiyor',
        'postoje stavke sa ne dodeljenom vrstom odrzavanja': 'Bakım türü atanmamış öğeler var. Belgeyi onaylamak istiyor musunuz?',
        'fakturaNaOsnovuRadnogNaloga': 'Servis faturası (iş emri ile)',
        'fakturaBezRadnogNaloga': 'Servis teknisyeni faturası (iş emri olmadan)',
        saRadnimNalogom: 'İş emri ile',
        bezRadnogNaloga: 'İş emri yok',
        radniNalozi: 'İş emirleri',
        fakture: 'Faturalar',
        skladisteDelova: 'Depo parçaları',
        sopstveniDelovi: 'Kendi parçaları',
        stavke: 'Öğeler',
        dodajStavku: 'Bir öğe ekleyin',
        referenca: 'Referans',
        'ukupan iznos se ne slaze': "Toplam miktar uymuyor",
        'da li zelite da zakljucite fakturu': "Faturayı kilitlemek istiyor musunuz",
        potvrdaPovratnice: 'Makbuz onayı',
        prijemnica: 'Resepsiyon',
        zalihe: 'Gereçler',
        brojFaktureDobavljaca: 'Satıcı fatura numarası',
        rokPlacanja: 'Ödeme günü',
        pregledZaliha: 'Stoka genel bakış',
        pretrazi: 'Arama',
        nazivArtikla: 'Makale adı',
        poslednjaNabavnaCena: 'Son satın alma fiyatı',
        minZaliha: 'Min.Stok',
        maxZaliha: 'Max.Stok',
        vrednost: 'Değer',
        robuVratio: 'Malları iade etti',
        fakturaTroskovaVoznogParka: 'Filo maliyet faturası',
        vrsteTroska: 'Maliyet türleri',
        robuPrimio: 'Malları aldı',
        autoServis: 'Oto Servis',
        'podaci nisu sacuvani jer skladiste nije izabrano': 'Depo seçilmediğinden veriler kaydedilmedi',
        'nisu sva obavezna polja popunjena': 'Gerekli alanların tümü doldurulmamış',
        'potvrdjena kolicina ne sme biti veca od kolicine':'Teyit edilen miktar, miktarı aşmamalıdır',
        sacuvajNalog: 'Hesabı kaydedin',
        delatnost: 'Aktivite',
        'kolicina na stavkama i na raspodeli se ne slazu': 'Öğelerdeki ve mevcut olan miktar eşleşmiyor',
        'raspodela troskova po vozilima': 'Araca göre maliyet dağıtımı',
        pregledDokumenta: 'Belgeye genel bakış',
        prethodniDokument: 'Önceki belge',
        povezaniDokumenti: 'İlgili belgeler',
        deloveIzdao: 'Verilen parçalar',
        deloveVratio: 'Parçalar iade edildi',
        detaljiDokumenta: 'Belge ayrıntıları',
        fakturisaniDelovi: 'Faturalı parçalar',
        pretragaDokumenata: 'Belge arama',
        podesavanjeSistema: 'Sistem kurulumu',
        cenaRadnogSata: 'Çalışma saati başına fiyat',
        koristiZalihe: 'Stok kullan',
        upozoriPre: 'Önceden uyar',
        primaoci: 'Alıcılar',
        primaoc: 'Alıcı',
        ukljucen: 'Açık',
        podsetnici: 'Hatırlatmalar',
        dodajPodsetnik: 'Hatırlatıcı ekle',
        dodajPodsetnikVozila: 'Araç hatırlatıcısı ekleyin',
        dodajPrimaoca: 'Alıcı ekle',
        zaglavljeDokumenta: 'Belge başlığı',
        dana: 'Günün',
        imeIPrezime: 'Adı ve soyadı',
        podaciZaposlenog: 'Çalışan verileri',
        korisnickiNalog: 'Kullanıcı hesabı',
        poruke: 'Mesajlar',
        obrisiSve: 'Hepsini sil',
        pogledajSve: 'Her şeye bak',
        nemateNovihPoruka: 'Yeni mesajınız yok',
        razlika: 'Fark',
        osoba: 'Bir kişi',
        podsetniciVozila: 'Araç hatırlatıcıları',
        dodajPodsetnikOsobe: 'Bir kişinin hatırlatıcısını ekleyin',
        podsetniciOsoba: 'Kişi hatırlatıcıları',
        km: ' km',
        danaUpozoriPre: ' Günün',
        danUpozoriPre: ' Gün',
        'da li zelite da obrisete podsetnik': 'Hatırlatıcıyı silmek istiyor musun',
        prikazSaKilometrazom: 'Kilometre göstergesi',
        datumskiPrikaz: 'Tarih görünümü',
        evidencijaRV: 'Çalışma saatlerinin kayıtları',
        unosOdsustva: 'Devamsızlığı girin',
        vrstaOdsustva: 'Yokluğun türü',
        od: 'İtibaren',
        odDatuma: 'İtibaren',
        doDatuma: 'Güncel',
        'podaci nisu validni': 'Veri geçersiz. Hataları düzelt',
        'da li zelite da obrisete odsustvo': 'İzni silmek istiyor musun',
        januar: 'Ocak',
        februar: 'Şubat',
        mart: 'Mart',
        april: 'Nisan',
        maj: 'Mayıs',
        jun: 'Haz',
        jul: 'Tem',
        avgust: 'Ağustos',
        septembar: 'Eylül',
        oktobar: 'Ekim',
        novembar: 'Kasım',
        decembar: 'Aralık',
        evidencijaRadnogVremena: 'Çalışma saatlerinin kayıtları',
        mesec: 'ay',
        mestoTroska: 'Maliyet yeri',
        vozac: 'Sürücü',
        pocetakRV: 'Çalışma saatlerinin başlangıcı',
        krajRV: 'Karavan sonu',
        trajanjeRV: 'Süre sk',
        vremeVoznje: 'Sürüş zamanı',
        ostaloRV: 'Diğer sk',
        raspolozivoVreme: 'Müsait zaman',
        odmorURV: 'Tatil u sk',
        nocnoRadnoVreme: 'Gece çalışma saatleri',
        placenoOdsustvo: 'Ücretli izin',
        pregledReferentnihPerioda: 'Referans dönemlerine genel bakış',
        period: 'Zaman aralığı',
        nedelja: 'Pazar',
        ukupnoVreme: 'Güzel hava',
        nedelja1: '1. hafta',
        nedelja2: '2. hafta',
        nedelja3: '3. hafta',
        nedelja4: '4. hafta',
        nedelja5: '5. hafta',
        prosecnoVreme: 'Ortalama süre',
        ukupnoRV: 'Toplam sk',
        produzenoVreme: 'Uzatılmış çalışma saatleri',
        rvNedelja: 'RV Karavan Pazar',
        preostaloVremeDanas: 'Bugün kalan zaman',
        preostaloVremeNedelja: 'Kalan zaman haftaları',
        preostaloVremePeriod: 'Kalan süre',
        prosecnoVremeUPeriodu: 'Dönem içindeki ortalama süre',
        preostaloVremeSutra: 'Yarın kalan zaman',
        rvDanas: 'RV Bugün karavan',
        izvestajPreostalogRadnogVremena: 'Kalan çalışma saatlerinin raporu',
        uvozTahografa: 'Takografın içe aktarılması',
        naloziZaSluzbenoPutovanje: 'İş seyahati siparişleri',
        putniNalozi: 'Seyahat emirleri',
        brojNaloga: 'Sipariş numarası',
        datumPolaska: 'Ayrılış tarihi',
        datumZavrsetka: 'Tamamlama tarihi',
        brojSati: 'Saat sayısı',
        brojDnevnica: 'Günlük harcırah sayısı',
        iznosDnevnice: 'Günlük tutar',
        predjenoKM: 'Kilometre',
        unosPutnogNaloga: 'Seyahat sırasını girin',
        brojPutnogNaloga: 'Seyahat sipariş numarası',
        vrstaPrevoza: 'Taşıma tipi',
        relacija: 'İlişki',
        clanPosade: 'Mürettebat üyesi',
        podaciOKretanju: 'Hareket verileri',
        troskovi: 'Maliyetler',
        vremePolaska: 'Kalkış zamanı',
        mestoPolaska: 'Kalkış yeri',
        mestoDolaska: 'Varış yeri',
        vremeDolaska: 'Varış zamanı',
        datumDolaska: 'varış tarihi',
        ukupnoKM: 'Toplam km',
        stanjeKM: 'Durum km',
        'datum unosa': 'Giriş tarihi',
        'naziv datoteke': 'Dosya adı',
        'Choose a file or drop it here...': 'Bir dosya seçin',
        ukupnaKM: 'Toplam km',
        pocetnaKM: 'İlk kilometre',
        popust: 'İndirim %',
        servisnaFaktura: 'Servis faturası',
        kilometraza: 'Kilometre',
        dodajNalog: 'Bir hesap ekle',
        krajnjaKM: 'Aşırı km',
        krajnjaKilometraza: 'Son kilometre',
        predjenaKilometraza: 'Kilometre',
        pregledPutnihNaloga: 'Seyahat siparişlerine genel bakış',
        polaznaKM: 'Başlangıç km',
        'ovaj putni nalog je vec zakljucan i izmene nisu dozvoljene': 'Bu seyahat emri zaten kilitlenmiş ve hiçbir değişikliğe izin verilmiyor',
        dodajKretanje: 'Hareket ekle',
        vrstaTroska: 'Maliyet türü',
        datumIVremePolaska: 'Kalkış tarihi ve saati',
        datumIVremeDolaska: 'Varış tarihi ve saati',
        ukupnaKilometraza: 'Toplam kilometre',
        ukupanTrosak: 'Toplam tutar',
        dodajTrosak: 'Maliyet ekleyin',
        prevozZaSopstvenePotrebe: 'Kendi ihtiyaçları için',
        javniPrevoz: 'toplu taşıma',
        brojRadnihDanaUNedelji: 'Haftalık çalışma günü sayısı',
        brojRadnihSatiUDanu: 'Günlük çalışma saati sayısı',
        kursEvra: 'EUR için',
        iznosDnevniceVozaca: 'Sürücünün günlük ödeneği',
        osveziPoziciju: 'Konumu yenile',
        automatskoOsvezavanje: 'Otomatik yenileme',
        interval: 'Aralık',
        'pozicije su osvezene': 'Pozisyonlar yenilendi',
        min: 'Min',
        pregledPodsetnikaPoPrimaocima: 'Alıcılara göre hatırlatıcıları görüntüleyin',
        'da li zelite da zakljucite putni nalog': 'Bir seyahat emrini tamamlamak istiyor musunuz?',
        zadatak: 'Görev',
        putniNalog: 'Seyahat emri',
        uvozPodataka: 'Veri içe aktarma',
        uvozSipanjaGoriva: 'Yakıt ithalatı',
        izvestaji: 'Raporlar',
        adBlue: 'Ad Blue',
        takse: 'Vergiler',
        osiguranje: 'Sigorta',
        amortizacija: 'Amortisman',
        inventarskiVozniPark: 'Envanter vagonları',
        preventive: 'Önleyici maliyetler',
        corrective: 'Düzeltici maliyetler',
        welcome: 'Hoşgeldiniz',
        ukupniTroskovi: 'Toplam tutar',
        ukupnoPrevezeniTeret: 'Taşınan toplam yük',
        ukupnoPredjenaKilometraza: 'Toplam kilometre',
        pcTroskoviPoGodinama: 'Yıllara göre önleyici / düzeltici bakım maliyetleri',
        ucesceUUkupnimTroskovima: 'Toplam maliyetlerdeki pay',
        pcTroskoviPoGrupama: 'Gruplara göre önleyici / düzeltici bakım maliyetleri',
        troskoviOdrzavanjaPoVozilima: 'Araç başına bakım maliyetleri (top 10)',
        uvozKretanjaVozila: 'Araç hareketlerinin ithalatı',
        evidencijaSipanjaGoriva: 'Doldurma kayıtları ve ortalama yakıt tüketimi',
        stanjeKilometrazePriSipanju: 'Deşarj kilometre durumu',
        predjenoKilometaraNakonPrethodnogSipanja: 'Önceki dökülmeden sonraki kilometre',
        vrednostSipanogGoriva: 'Yakıt dökülme değeri',
        sipanaKolicina: 'Dökülen miktar',
        prosecnaPotrosnjaGoriva: 'Ortalama yakıt tüketimi',
        normiranaPotrosnja: 'Standart tüketim',
        prekoracenjeNorme: 'Normu aşmak',
        prekoracenjeULitrama: 'Litre cinsinden aşan',
        prekoracenjeUVrednosti: 'Kredili mevduat',
        total: 'Toplamda',
        tipDokumenta: 'Belge',
        troskoviOdrzavanja: 'Bakım maliyetleri',
        iznosAmortizacije: 'Amortisman tutarı',
        preostaliIznos: 'Kalan miktar',
        predjeniKilometriIPotrosnjaGoriva: 'Kilometre performansı ve yakıt tüketimi',
        predjeniKilometri: 'Kilometre (km)',
        potrosnjaGorivaULitrama: 'Yakıt tüketimi (l)',
        troskoviPoVozilima: 'Araç başına maliyetler',
        markaIModel: 'Araç markası ve modeli',
        trosakPoKm: 'Km başına maliyet',
        izvestajPredjeniKilometri: 'Kilometre',
        ukupnoPredjeniKilometriVozila: 'Kat edilen toplam kilometre',
        ucesceUUkupnoPredjenimKilometrimaVozila: 'Aracın toplam kilometresine katılım',
        ucesceUUkupnoPredjenimKilometrimaVoznogParka: 'Tüm araç filosunun kat ettiği toplam kilometreye katılım',
        predjeniKilometriPoVozilima: 'Araç başına kilometre',
        predjeniKilometriPoVozacima: 'Sürücü başına kilometre',
        kretanje: 'Dolaşmak',
        radnoVreme: 'Çalışma saati',
        pregledKretanjaVozila: 'Araç hareketine genel bakış',
        pregledKretanjaVozaca: 'Sürücü hareketine genel bakış',
        prosek: 'Ortalama',
        ostaliTroskovi: 'Diğer giderler',
        osnovica: 'Temel',
        pdvStopa: 'KDV %',
        'pretraga dokumenata': 'Belge arama',
        nemaUnetihStavki: 'Hiçbir öğe girilmedi',
        korisnickeTransakcije: 'Kullanıcı işlemleri',
        transakcijaNijeDozvoljena: 'Kullanıcı hesabınız için işleme izin verilmiyor',
        upozorenje: 'Uyarı',
        mestoRodjenja: 'Doğum yeri',
        b2bPodaci: 'B2B verileri',
        provajder: 'Sağlayıcı',
        vrstaProvajdera: 'Sağlayıcı türü',
        gps: 'GPS',
        unosAktivnostiIObradaGpsPodataka: 'Etkinlik girişi ve GPS veri işleme',
        izvor: 'Kaynak',
        pocetnaLokacija: 'Ev konumu',
        krajnjaLokacija: 'Nihai konum',
        aktivnost: 'Aktivite',
        trajanjeAktivnosti: 'Faaliyetin süresi',
        ucitajSaGpsa: "Gps'den indirin",
        unosIzmenaAktivnosti: 'Aktiviteleri girin / düzenleyin',
        za: 'İçin',
        pre: 'Önce',
        stete: 'Çok kötü',
        unosStetnogDogadjaja: 'Zararlı bir olay girin',
        pregledSteta: 'Hasar incelemesi',
        brojStete: 'Hasar numarası',
        brojZapisnika: 'Dakika sayısı',
        otkazi: 'İptal etmek',
        zapisnikStete: 'Hasar kaydı',
        steta: 'yazık',
        brojSteteSaZapisnika: 'Dakika sayısı',
        datumZakljucenja: 'Kapanış tarihi',
        zakljuciStetu: 'Hasarı sonuçlandırın',
        osiguranjePriznalo: 'Sigorta kabul edildi',
        'steta je vec zakljucena. dalje izmene nisu dozvoljene': 'Hasar çoktan sonuçlandı. Daha fazla değişikliğe izin verilmez.',
        novaPoruka: 'Yeni sistem mesajı',
        voziloNijePronadjeno: 'Araç bulunamadı',
        rezultatPretrage: 'Arama sonuçları',
        mojProfil: 'Benim profilim',
        'vasa lozinka je uspesno promenjena': 'şifreniz başarıyla değiştirildi',
        nabavnaCena: 'Satınalma fiyatı',
        spojiDane: 'Günleri bağlayın',
        ukupnoMinuta: 'Toplam dakika',
        ukupnoSati: 'Çılgın saatler',
        'nije moguce spojiti radno vreme. vozac se razlikuje': 'Çalışma saatlerini bağlamak mümkün değildir - sürücü farklıdır',
        'nije moguce spojiti radno vreme. razlika datuma je razlicita od 1': "İş saatlerine bağlanılamıyor. Tarih farkı 1'den farklı",
        unosTroskaSluzbenogPuta: 'İş gezisinin maliyetini girin',
        izmenaKilometrazeSipanja: 'Doldurma kilometresinin değiştirilmesi',
        analitikaTroskovaVozila: 'Bakım maliyeti analizi',
        iznosZaObracun: 'Fatura bedeli',
        tipStavke: 'R/D'
    }
}
